/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import { useResponsive, MEDIA_TYPES, Responsive } from 'lidya-common-components';
import featured from './getFeatured';
import { featuredMap } from './newsFeed';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './home.featured.in.less';

const Featured = function ({ title }) {
  const { country } = useGlobalData();
  const { t } = useTranslation();
  const {
    context: { currentMedia },
  } = useResponsive();
  const isPhone = MEDIA_TYPES.PHONE.includes(currentMedia);
  const titleToUse = title || 'web.home.featured.title';
  const newsForCountry = Object.values(featuredMap)
    .map((feature) => {
      if (feature.countries.includes(country)) {
        return feature;
      }
      return null;
    })
    .filter((el) => el != null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isPhone ? 2 : 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 2000,
  };
  return (
    newsForCountry.length > 0 && (
      <div className="o-featured">
        <div className="m-globalContentContainer -featured">
          <div className="m-featured__titleContainer">
            <h1 className="a-featured__title">
              <Trans>{titleToUse}</Trans>
            </h1>
          </div>
          <Slider {...settings}>
            {newsForCountry.map((feature) => {
              if (feature.isLidya) return null;
              return (
                <a
                  className="m-featured__imageContainer"
                  key={feature.name}
                  href={feature.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Featured In ${feature.name}`}
                >
                  <GatsbyImage
                    image={featured(feature.img)}
                    className="a-featured__image"
                    alt={t('images.name.logo.alt', { name: feature.alt })}
                    title={t('images.press.logo.title')}
                  />
                </a>
              );
            })}
          </Slider>
        </div>
      </div>
    )
  );
};

Featured.propTypes = {
  title: PropTypes.string,
};

Featured.defaultProps = {
  title: undefined,
};

function FeaturedAgg(props) {
  return (
    <Responsive>
      <Featured {...props} />
    </Responsive>
  );
}

export default FeaturedAgg;
